import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import withInspector from 'fulogics-ui-web/dist/layout/inspector/hoc/withInspector';
import WmsExternalIdsSimpleTextSchema from './WmsExternalIdsSimpleTextSchema';
import { useId } from 'react-id-generator';
import style from './WmsExternalIdsSimpleText.module.scss';
import Button from 'fulogics-ui-web/dist/layout/dx/Button/Button';
import Popover from 'devextreme-react/popover';

const WmsExternalIdsSimpleText = React.memo((props: WmsExternalIdsSimpleTextProps) => {
    const { t } = useTranslation('WmsExternalIdsColumn');

    const showButton = !!props.data?.wmsOrderIds;
    const [targetId] = useId();
    let ids: Array<string> = [];

    if (props.data?.wmsOrderIds) {
        ids = props.data?.wmsOrderIds.split(',');
    }

    return (
        <div className={props.className}>
            {props.data?.wmsExternalId}
            {showButton && (
                <Button id={targetId} stylingMode="text">
                    +{ids.length}
                </Button>
            )}
            {props.data?.wmsOrderIds ? (
                <Popover
                    target={`#${targetId}`}
                    showEvent="dxhoverstart"
                    hideEvent="dxclick"
                    width="172px"
                    height="auto"
                >
                    <div className={classNames(style.popupContainer)}>
                        {ids.map((element, i) => (
                            <div
                                key={`${i}-${element}-${targetId}`}
                                className={classNames(style.popupElement)}
                            >
                                {t('idNumber')} {i + 1}: {element}
                            </div>
                        ))}
                    </div>
                </Popover>
            ) : null}
        </div>
    );
});

export type WmsExternalIdsSimpleTextProps = {
    data?: WmsExternalIdsSimpleTextData;
} & WmsExternalIdsSimpleTextDisplayOptions;

export default withInspector<WmsExternalIdsSimpleTextProps>(
    WmsExternalIdsSimpleText,
    WmsExternalIdsSimpleTextSchema
);

export class WmsExternalIdsSimpleTextDisplayOptions {
    className?: string;
}

export type WmsExternalIdsSimpleTextData = {
    wmsExternalId?: string;
    wmsOrderIds?: string;
};

export const WmsExternalIdsSimpleTextDataKeys = ['wmsExternalId', 'wmsOrderIds'];
